import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import * as Highcharts from 'highcharts';
import { TranslocoService, translate } from '@jsverse/transloco';

@Component({
  selector: 'app-context-metrices-bar-chart',
  templateUrl: './context-metrices-bar-chart.component.html',
  styleUrl: './context-metrices-bar-chart.component.sass',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContextMetricesBarChartComponent {
  constructor(private transloco: TranslocoService) {}
  @Input() chartData: any = null;
  Highcharts: typeof Highcharts = Highcharts;
  hasData = false;
  chartOptions: Highcharts.Options = {
    chart: {
      type: 'column',
      backgroundColor: '#f7f6ff',
      height: 200,
      spacingBottom: 20,
      spacingTop: 20,
      spacingLeft: 10,
      spacingRight: 10  
    },
    title: { text: '' },
    credits: { enabled: false },
    legend: { enabled: false },

    xAxis: {
      type: 'category',
      lineColor: '#7b6cff',
      lineWidth: 2,
      tickLength: 0,
      minPadding: 0,
      maxPadding: 0,
      min: 0,
      max: 4,
      labels: {
        style: {
          color: '#7b6cff',
          fontSize: '24px',
          fontWeight: '500'
        }
      }
    },

    yAxis: {
      visible: false,
    },

    tooltip: { enabled: true },

    plotOptions: {
      column: {
        borderWidth: 0,
        pointPadding: 0,
        groupPadding: 0.025,
        grouping: false,
        dataLabels: {
          enabled: true,
          inside: false,
          style: {
            color: '#000',
            fontSize: '24px',
            textOutline: 'none'
          },
          formatter: function () {
            return this.y?.toString() ?? '';
          }
        }
      },
      series: {
        states: {
          hover: {
            enabled: false
          }
        }
      }
    },

    series: [
      {
        type: 'column',
        data: [
          { y: 120, name: '0-14 jaar', color: '#8f6bff' },
          { y: 270, name: '15-24 jaar', color: '#d7ccff' },
          { y: 125, name: '25-44 jaar', color: '#e6dcff' },
          { y: 395, name: '45-64 jaar', color: '#a494d8' },
          { y: 565, name: '65+ jaar', color: '#6a5c95' },
        ]
      }
    ]
  };

  ngOnInit() {
    if (!this.chartData?.parameters?.length) {
      this.hasData = false;
      return;
    }

    const sourceData = this.chartData.parameters[0].source_data;

    if (!sourceData || Object.keys(sourceData).length === 0) {
      this.hasData = false;
      return;
    }

    // Filter out null, undefined, or empty values and exclude "Antal inwoners" key
    const highchartData = Object.entries(sourceData)
      .filter(([key, val]) => 
        key !== 'a_inw' && // Exclude "Antal inwoners" key
        val !== null && 
        val !== undefined && 
        val !== '' && 
        !isNaN(Number(val))
      )
      .map(([key, val], i) => ({
        name: this.transloco.translate('social_context.' + key) !== 'social_context.' + key
          ? this.transloco.translate('social_context.' + key)
          : key,
        y: Number(val),
        color: ['#8f6bff','#d7ccff','#e6dcff','#a494d8','#6a5c95'][i]
      }));

    if (highchartData.length === 0) {
      this.hasData = false;
      return;
    }

    this.hasData = true;
    const dataLength = highchartData.length;

    this.chartOptions = {
      chart: {
        type: 'column',
        backgroundColor: '#f7f6ff',
        height: 200,
        spacingBottom: 20,
        spacingTop: 20,
        spacingLeft: 10,
        spacingRight: 10  
      },
      title: { text: '' },
      credits: { enabled: false },
      legend: { enabled: false },
      xAxis: {
        type: 'category',
        lineColor: '#7b6cff',
        lineWidth: 2,
        tickLength: 0,
        minPadding: 0,
        maxPadding: 0,
        min: 0,
        max: dataLength > 0 ? dataLength - 1 : 0,
        labels: {
          style: {
            color: '#7b6cff',
            fontSize: '24px',
            fontWeight: '500'
          }
        }
      },
      yAxis: {
        visible: false,
      },
      tooltip: { enabled: true },
      plotOptions: {
        column: {
          borderWidth: 0,
          pointPadding: 0,
          groupPadding: 0.025,
          grouping: false,
          dataLabels: {
            enabled: true,
            inside: false,
            style: {
              color: '#000',
              fontSize: '24px',
              textOutline: 'none'
            },
            formatter: function () {
              return this.y?.toString() ?? '';
            }
          }
        },
        series: {
          states: {
            hover: {
              enabled: false
            }
          }
        }
      },
      series: [
        {
          type: 'column',
          data: highchartData
        }
      ]
    };
  }
}
